<template>
  <div id="components-modal-demo-position">
    <a-modal centered
             :visible="true"
             title="专利365"
             :footer="null"
             @cancel="cancel"
             class="addForm">
      <div class="code-modal">
        <IconWrap :width="200"
                  :height="200"
                  :url="codeUrl"
                  class="step-icon"></IconWrap>
        <div class="model-title">
          请用手机扫描二维码，365天，专利信息随时随地触手可及！
        </div>
      </div>
    </a-modal>
  </div>
</template>
<script>
import IconWrap from '@/components/common/IconWrap'

export default {
  props: {},
  data() {
    return {
      Visible: true,
      codeUrl: require('@/assets/images/二维码广州.png'),
    }
  },
  components: {
    IconWrap,
  },
  mounted() {
    if (process.env.VUE_APP_KEY === 'zhongshan') {
      this.codeUrl = require('@/assets/images/zhonshanImg/二维码中山.png')
      console.log(this.codeUrl)
    }
  },
  methods: {
    handleCancel() {
      this.$emit('cancelVisible', false)
    },
    cancel() {
      this.$emit('cancel')
    },
  },
}
</script>
<style lang="scss" scoped></style>
